import type { DungeonMeta } from "@/dungeon/dungeon-meta";
import { getDungeonFloorConfig, isActiveDungeonFloorConfig } from "@/dungeon/dungeon-floor-config";
import type { DungeonFloorPublishSnapshot } from "@/dungeon/dungeon-publish";

export const DUNGEON_PUBLISH_MAX_BYTES = 900_000;

export type DungeonPublishValidation =
  | { ok: true }
  | { ok: false; reason: string };

export function validateDungeonFloorsForPublish(
  meta: DungeonMeta,
  floorSnapshots?: DungeonFloorPublishSnapshot[],
): DungeonPublishValidation {
  if (!meta.published) return { ok: true };

  for (let f = 1; f <= meta.maxFloors; f += 1) {
    const snap = floorSnapshots?.find((s) => s.floor === f);
    const config = getDungeonFloorConfig(f);
    const active = snap
      ? snap.enabled && (snap.spawns?.length ?? 0) > 0
      : isActiveDungeonFloorConfig(config);
    if (!active) {
      return {
        ok: false,
        reason: `ด่าน ${f} ยังไม่พร้อม — ตั้งมอนสเตอร์และเปิดใช้งานก่อนเผยแพร่`,
      };
    }
  }
  return { ok: true };
}

export function validateDungeonPublishPayloadSize(payload: unknown): DungeonPublishValidation {
  try {
    const bytes = new TextEncoder().encode(JSON.stringify(payload)).length;
    if (bytes > DUNGEON_PUBLISH_MAX_BYTES) {
      return {
        ok: false,
        reason: `ข้อมูลด่านใหญ่เกินไป (${Math.round(bytes / 1024)} KB) — ลดรูป/ชั้นก่อนเผยแพร่`,
      };
    }
  } catch {
    return { ok: false, reason: "ข้อมูลด่านไม่ถูกต้อง" };
  }
  return { ok: true };
}
